import { render, staticRenderFns } from "./notifi.vue?vue&type=template&id=0bae4358"
import script from "./notifi.vue?vue&type=script&lang=js"
export * from "./notifi.vue?vue&type=script&lang=js"
import style0 from "./notifi.vue?vue&type=style&index=0&id=0bae4358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports